// Inspired by Sentry's own configuration, which excludes many of these:
// https://github.com/getsentry/sentry/blob/af7ff5471f894f950790173d0db088f416b966fc/static/app/bootstrap/initializeSdk.tsx#L137-L151
export const sentryIgnoreErrors = [
  /AbortError: Fetch is aborted/i,
  /AbortError: The operation was aborted/i,
  /AbortError: signal is aborted without reason/i,
  /AbortError: The user aborted a request/i,
  /AbortError: The fetching process for the media resource was aborted/i,
  // Browser extension content scripts. thirdPartyErrorFilterIntegration can't
  // reach these because Safari reports them with no stack frames to classify.
  /Invalid call to runtime\.(sendMessage|connect)\(\)/i,
  /Extension context invalidated/i,
  /Could not establish connection\. Receiving end does not exist/i,
  /Object Not Found Matching Id:.*MethodName:.*ParamCount:/i,
];
